export default "__VITE_ASSET__f06b8ec1__"